import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import Contactohero from "./sections/Contactohero";
import ServiceZones from "./sections/ServiceZones";
export default function ContactPage() {
  return <div>
      <Header />
      <Contactohero />
      <Inquiry />
      <Contact />
      <ServiceZones />
      <Footer />
    </div>;
}